function websiteAnimations() {
  return {
    step: 1,

  }
}

export { websiteAnimations };